<ng-template #contentTpl>
  <div class="flex items-center" [class.!items-start]="(label() || text()) && title()">
    @if (icon()) {
      <mobi-ui-icon-major [name]="icon()!" class="mobi-ui-text-inked mr-4 !w-7 !h-7" />
    }
    @if (title() || label() || text()) {
      <div class="flex flex-col">
        @if (title()) {
          <span
            class="text-black mobi-ui-font-size-150"
            [class]="{
              'mobi-ui-font-bold': label() || bold(),
              'mobi-ui-font-medium': !bold() && !label(),
            }"
            >{{ title() }}</span
          >
        }
        @if (label()) {
          <span class="mobi-ui-font-light text-black mobi-ui-font-size-150">{{
            label()
          }}</span>
        }
        @if (text()) {
          <mobi-text
            [data]="text()!"
            class="mobi-ui-font-light block mobi-ui-font-size-100 font-light text-black"
          />
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #linkIconTpl>
  <mobi-ui-icon-major
    [name]="isDocumentLink() ? 'download' : linkIcon()"
    class="mobi-ui-ink-grey"
    [ngClass]="{
      'mobi-ui-animation-horizontal-wiggle-init mobi-ui-animation-horizontal-wiggle-hover-target':
        linkIcon() === 'go_to_link' && !isDocumentLink(),
      'block mobi-ui-animation-scale-up-init mobi-ui-animation-scale-up-hover-target':
        linkIcon() !== 'go_to_link' || isDocumentLink(),
    }"
  />
</ng-template>

<ng-template #srOnlyTpl>
  @if (target() === '_blank') {
    <span class="sr-only">
      Link ({{
        'opens in new tab'
          | texts: { context: 'frontend', default: 'öffnet sich in einem neuen Tab' }
      }})
    </span>
  }
</ng-template>

<a
  class="icon-link flex justify-between items-center p-3 mobi-ui-animation-trigger-hover cursor-pointer"
  [class.!items-start]="(label() || text()) && title()"
  [betterRouterLink]="link() || ''"
  [target]="target() || '_self'"
  role="link"
  tabindex="0"
>
  <ng-container *ngTemplateOutlet="contentTpl" />
  <span
    class="flex items-center justify-center"
    [class]="{
      'external-link':
        target() === '_blank' && linkIcon() !== 'telephone' && !isDocumentLink(),
    }"
  >
    <ng-container *ngTemplateOutlet="linkIconTpl" />
  </span>
  <ng-container *ngTemplateOutlet="srOnlyTpl" />
</a>
